/**
 * Story 188 (RN3b): the active extended fields of the workflow go right after Description, in the
 * order the definitions arrive, in the selection tables of the Workflows Manager and Balance.
 */
export const withExtendedColumnsAfterDescription = (columns, extendedColumns) => {
  const afterDescription = columns.findIndex((column) => column.field === 'description') + 1
  return [...columns.slice(0, afterDescription), ...extendedColumns, ...columns.slice(afterDescription)]
}
